import { z } from 'zod'

/** Read/import contract. New intake continues to use IntakeEntryCode. */
export const EntryCode = z
  .string()
  .length(4)
  .regex(
    /^(?!0000)[0-9A-Z]{4}$/,
    'Exhibit ID must be four uppercase letters or digits and cannot be 0000'
  )

/** Historical indexes never overlap the numeric allocation pool or each other. */
export function historicalIdentifierOrder(value: string): number | null {
  if (!EntryCode.safeParse(value).success) return null
  return /^[0-9]{4}$/.test(value) ? 10000 + Number(value) : 20000 + parseInt(value, 36)
}
